import React, { useEffect,useState } from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function CreatingDraftModal(props) {

    const {creatingDraft} = props;
  return (
    <Dialog
      open={creatingDraft}
      // onClose={() => handleClose(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogContent>
        <DialogTitle  id="confirmation-dialog-title">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection:"column"}}>
            <div>Generating draft for the selected forms...</div>
            <br></br>
            <div style={{margin:"auto"}}> <CircularProgress /></div>
        </div>
        </DialogTitle>
      </DialogContent>
      
    </Dialog>
  );
}
